// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2tj4h","title":"Images45_title__2AGlp","images":"Images45_images__3RdvF"};